//
//
//
//
//
//
export default {
  name: 'SemipolarSpinner',
  props: {
    animationDuration: {
      type: Number,
      "default": 2000
    },
    size: {
      type: Number,
      "default": 65
    },
    color: {
      type: String,
      "default": '#fff'
    }
  },
  data: function data() {
    return {
      ringsNum: 5
    };
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: "".concat(this.size, "px"),
        width: "".concat(this.size, "px")
      };
    },
    ringStyle: function ringStyle() {
      return {
        animationDuration: "".concat(this.animationDuration, "ms"),
        borderTopColor: this.color,
        borderLeftColor: this.color
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var delayModifier = 0.1;
      var ringWidth = this.size * 0.05;
      var positionIncrement = ringWidth * 2;
      var sizeDecrement = this.size * 0.2;

      for (var i = 0; i < this.ringsNum; i++) {
        var computedSize = "".concat(this.size - sizeDecrement * i, "px");
        var computedPosition = "".concat(positionIncrement * i, "px");
        var style = Object.assign({
          animationDelay: "".concat(this.animationDuration * delayModifier * (this.ringsNum - i - 1), "ms"),
          height: computedSize,
          width: computedSize,
          left: computedPosition,
          top: computedPosition,
          borderWidth: "".concat(ringWidth, "px")
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
};